/**
 * å½åè®¾å¤çä¸äºä¿¡æ¯
 */
export class DeviceInfo {
  /**
   * æµè§å¨ç¨æ·ä»£çä¿¡æ¯
   */
  userAgent: string;
  /**
   * æµè§å¨ç±»å(chrome, firefox, ...)åçæ¬å·ä¿¡æ¯
   * ä¾: chrome 63
   */
  browser: string;
  /**
   * è®¾å¤å±å¹å®½é«
   * ä¾: 360 * 640
   */
  screen: string;
  /**
   * åæ ¸å¹³å°ä¿¡æ¯
   * ä¾: MacIntel
   */
  platform: string;
  /**
   * æ¯å¦æ¯å¾®ä¿¡æµè§å¨ & çæ¬ä¿¡æ¯
   * ä¾: MicroMessenger/6.5.7.1077
   */
  weChatVersion: string;
  /**
   * è®¾å¤ç³»ç»ä¿¡æ¯
   * ä¾: Android 4.4.2 / iPhone OS 11.2.1
   */
  system: string;

  /**
   * å¨æé çæ¶åå°±ç´æ¥è·åç¸å³æ°æ®
   */
  constructor() {
    this.userAgent = window.navigator.userAgent;
    this.browser = this.getBrowserInfo();
    this.screen = window.screen.width + ' * ' + window.screen.height;
    this.platform = window.navigator.platform;

    let weChatVersion = /MicroMessenger\/.*? /.exec(this.userAgent);
    this.weChatVersion = weChatVersion ? weChatVersion[0].slice(0, -1) : '';

    let androidVersion = /Android.*?;/.exec(this.userAgent);
    if (androidVersion) {
      this.system = androidVersion[0].slice(0, -1);
    }
    let iosVersion = /iPhone OS .*? /.exec(this.userAgent);
    if (iosVersion) {
      this.system = iosVersion[0].slice(0, -1);
    }
  }

  /**
   * è·åæµè§å¨ç±»ååçæ¬ä¿¡æ¯
   */
  private getBrowserInfo() {
    let ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (ua.toLowerCase().indexOf('mobile') >= 0) {
      return '';
    }

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) {
        return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return M.join(' ');
  }
}
